import { render, staticRenderFns } from "./PreQuestion2.vue?vue&type=template&id=3b9f5528&scoped=true&"
import script from "./PreQuestion2.vue?vue&type=script&lang=js&"
export * from "./PreQuestion2.vue?vue&type=script&lang=js&"
import style0 from "./PreQuestion2.vue?vue&type=style&index=0&id=3b9f5528&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f5528",
  null
  
)

export default component.exports